(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[552],{

/***/ 2879:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us",
      function () {
        return __webpack_require__(7747);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4199);
/* harmony import */ var _Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var gsap_dist_gsap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9521);
/* harmony import */ var gsap_dist_gsap__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(gsap_dist_gsap__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var gsap_dist_ScrollToPlugin__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9664);
/* harmony import */ var gsap_dist_ScrollToPlugin__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(gsap_dist_ScrollToPlugin__WEBPACK_IMPORTED_MODULE_4__);
/* provided dependency */ var process = __webpack_require__(3454);






if (process.client) {
    gsap_dist_gsap__WEBPACK_IMPORTED_MODULE_3__.gsap.registerPlugin(gsap_dist_ScrollToPlugin__WEBPACK_IMPORTED_MODULE_4__.ScrollToPlugin);
}
function TopBannerWithouth1(props) {
    const handleClick = (e)=>{
        gsap_dist_gsap__WEBPACK_IMPORTED_MODULE_3__.gsap.registerPlugin(gsap_dist_ScrollToPlugin__WEBPACK_IMPORTED_MODULE_4__.ScrollToPlugin);
        e.stopPropagation();
        gsap_dist_gsap__WEBPACK_IMPORTED_MODULE_3__.gsap.to(window, {
            duration: 1,
            scrollTo: {
                y: "".concat(props.target),
                offsetY: 70
            }
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            className: (_Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_5___default().top_banner),
            style: {
                backgroundImage: "url(".concat(props.bgImage, ")")
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_5___default().banner_text),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container common_title",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            children: props.title
                        }),
                        props.button ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/",
                            className: "common_btn",
                            children: props.button
                        }) : ""
                    ]
                })
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (TopBannerWithouth1);


/***/ }),

/***/ 5871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4199);
/* harmony import */ var _Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var gsap_dist_gsap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9521);
/* harmony import */ var gsap_dist_gsap__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(gsap_dist_gsap__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var gsap_dist_ScrollToPlugin__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9664);
/* harmony import */ var gsap_dist_ScrollToPlugin__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(gsap_dist_ScrollToPlugin__WEBPACK_IMPORTED_MODULE_4__);
/* provided dependency */ var process = __webpack_require__(3454);






if (process.client) {
    gsap_dist_gsap__WEBPACK_IMPORTED_MODULE_3__.gsap.registerPlugin(gsap_dist_ScrollToPlugin__WEBPACK_IMPORTED_MODULE_4__.ScrollToPlugin);
}
function Topbanner(props) {
    const handleClick = (e)=>{
        gsap_dist_gsap__WEBPACK_IMPORTED_MODULE_3__.gsap.registerPlugin(gsap_dist_ScrollToPlugin__WEBPACK_IMPORTED_MODULE_4__.ScrollToPlugin);
        e.stopPropagation();
        gsap_dist_gsap__WEBPACK_IMPORTED_MODULE_3__.gsap.to(window, {
            duration: 1,
            scrollTo: {
                y: "".concat(props.target),
                offsetY: 70
            }
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            className: (_Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_5___default().top_banner),
            style: {
                backgroundImage: "url(".concat(props.bgImage, ")")
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_5___default().banner_text),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container common_title",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            children: props.title
                        }),
                        props.button ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/",
                            className: "common_btn",
                            children: props.button
                        }) : ""
                    ]
                })
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Topbanner);


/***/ }),

/***/ 9518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

const useContactForm = ()=>{
    const [values, setValues] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        fullname: "",
        email: "",
        phoneno: "",
        message: ""
    });
    const handleChange = (e)=>{
        setValues((prevState)=>{
            return {
                ...prevState,
                [e.target.id]: e.target.value
            };
        });
    };
    return {
        values,
        handleChange
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useContactForm);


/***/ }),

/***/ 7747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ AboutUs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/styles/Pages/About.module.scss
var About_module = __webpack_require__(9859);
var About_module_default = /*#__PURE__*/__webpack_require__.n(About_module);
// EXTERNAL MODULE: ./src/components/Reusable/Banner/Topbanner.js
var Topbanner = __webpack_require__(5871);
// EXTERNAL MODULE: ./src/components/Reusable/Form/Form.module.scss
var Form_module = __webpack_require__(240);
var Form_module_default = /*#__PURE__*/__webpack_require__.n(Form_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 39 modules
var axios = __webpack_require__(594);
;// CONCATENATED MODULE: ./src/lib/sendAboutForm.js

const sendContactForm = async (fullname, email, phoneno, message)=>{
    return (0,axios/* default */.Z)({
        method: "post",
        url: "/api/send-about-mail",
        data: {
            fullname: fullname,
            email: email,
            phoneno: phoneno,
            message: message
        }
    });
};
/* harmony default export */ var sendAboutForm = (sendContactForm);

// EXTERNAL MODULE: ./src/hooks/useContactForm.js
var useContactForm = __webpack_require__(9518);
// EXTERNAL MODULE: ./src/components/Reusable/Buttons/Buttons.js
var Buttons = __webpack_require__(28);
;// CONCATENATED MODULE: ./src/components/Reusable/Form/Form.js






function Form() {
    const { values , handleChange  } = (0,useContactForm/* default */.Z)();
    const [responseMessage, setResponseMessage] = (0,react.useState)({
        isSuccessful: false,
        message: ""
    });
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setTimeout(()=>{
            setResponseMessage({
                isSuccessful: true
            }), values.fullname = "", values.email = "", values.phoneno = "", values.message = "";
        }, 3000);
        try {
            const req = await sendAboutForm(values.fullname, values.email, values.phoneno, values.message);
            if (req.status === 250) {
                setResponseMessage({
                    isSuccessful: true,
                    message: "Thank you for your message."
                });
                alert("Thank you for your message.");
            }
        } catch (e1) {
            console.log(e1);
            setResponseMessage({
                isSuccessful: false,
                message: "Oops something went wrong. Please try again."
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "".concat((Form_module_default()).form, " common_padding"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-md-8 offset-md-2 col-sm-12 contact_form",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        className: "row",
                        onSubmit: handleSubmit,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((Form_module_default()).form_group, " col-md-6 col-sm-12"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    id: "fullname",
                                    type: "text",
                                    name: "fullname",
                                    onChange: handleChange,
                                    value: values.fullname,
                                    className: "form-control",
                                    placeholder: "Full Name",
                                    required: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((Form_module_default()).form_group, " col-md-6 col-sm-12"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    id: "email",
                                    name: "email",
                                    type: "email",
                                    onChange: handleChange,
                                    value: values.email,
                                    className: "form-control",
                                    placeholder: "Your Email",
                                    required: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((Form_module_default()).form_group, " col-md-12"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    id: "phoneno",
                                    required: true,
                                    name: "phoneno",
                                    type: "number",
                                    onChange: handleChange,
                                    value: values.phoneno,
                                    className: "form-control",
                                    placeholder: "Phone Number"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((Form_module_default()).form_group, " col-md-12"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                    id: "message",
                                    name: "message",
                                    onChange: handleChange,
                                    value: values.message,
                                    className: "form-control",
                                    placeholder: "Message",
                                    required: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-12 text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* SecoundaryButton */.me, {
                                    type: "submit",
                                    buttonText: "SEND REQUEST"
                                })
                            }),
                            responseMessage.isSuccessful === true ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "success text-center",
                                children: "We appreciate you contacting us. One of our customer happiness members will be getting back to you shortly."
                            }) : ""
                        ]
                    })
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(6066);
// EXTERNAL MODULE: ./src/components/Reusable/OurBlogs/OurBlogs.js + 1 modules
var OurBlogs = __webpack_require__(9791);
// EXTERNAL MODULE: ./src/components/Reusable/Banner/TopBannerWithouth1.js
var TopBannerWithouth1 = __webpack_require__(1976);
;// CONCATENATED MODULE: ./src/pages/about-us.js









// import Aboutform from '../components/Reusable/Aboutform/Aboutform'
function AboutUs() {
    const highlights = [
        {
            icon: "/icons/adventure.svg",
            title: "Adventure Rides & Activities",
            description: "With over 20 activities, you may spend some quality time with your friends and family while having a great time at this place, which provides complete entertainment, amusement, food, and leisure."
        },
        {
            icon: "/icons/valley.svg",
            title: "Hotel with Beautiful Valley View",
            description: "Hotel with beautiful Valley view- Our hotel is surrounded by beautiful natural scenery, and the Himalayas provide a breathtaking backdrop. Spend your holidays with us, and you'll have the chance to relax in both luxury and tranquility"
        },
        {
            icon: "/icons/banquet.svg",
            title: "Banquet & Conference Hall",
            description: "We offer all the latest conveniences to ensure the success of your events and meetings, making us the obvious first option. If you're planning a destination wedding, we're the finest option since you can have it on our inside location or on our outside lawns."
        }
    ];
    const testimonial = [
        {
            name: "Aviral Mittal",
            title: "From India",
            description: "The best amusement park as well as family destination near shimla , better than mall road, enjoyable place for kids as well as adults"
        },
        {
            name: "Chetan Nagarrkar",
            title: "From India",
            description: "Good for learning skiing in season, has many other games and good for adventure sports which I didn't try. "
        },
        {
            name: "Gurpreet Kaur",
            title: "From India",
            description: "Fantabulous indoor and outdoor activities. Smash zone, 3 D cinema etc , restaurant ..too good.  Good memories."
        }
    ];
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Adventure Resorts | Best Adventure Park in Shimla, Kufri "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Adventure Resorts, Kufri offers the best adventure park in Shimla. Top thrilling adventure activities in Kufri and experience the best Shimla adventure. Book now!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: "Best Adventure Park, Shimla Adventure, Kufri Fun Park, Adventure Activities In Kufri"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.adventureresortkufri.com/about-us"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopBannerWithouth1/* default */.Z, {
                title: "About Us",
                bgImage: "/images/about-banner.png",
                target: "#firstsec"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "".concat((About_module_default()).top_sec, " common_padding"),
                id: "firstsec",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row ",
                        children: highlights.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((About_module_default()).highlight_child, " col-md-4 common_title "),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: item.icon,
                                            width: 44,
                                            height: 44,
                                            alt: item.title
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: item.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: item.description
                                    })
                                ]
                            }, index))
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "".concat((About_module_default()).about_main, " common_padding"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((About_module_default()).about_main_sec, " row"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((About_module_default()).about_main_sec_left, " col-md-4"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/images/about-main-img.png",
                                    alt: "about image"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((About_module_default()).about_main_sec_right, " col-sm-12 col-md-8"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((About_module_default()).left_child, " common_title"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            className: "common_h1",
                                            children: "Best Adventure Parks"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "The Adventure Resorts is situated in Kufri, near Shimla, with the Himalayas serving as a crown in the backdrop. The amusement park's founder has been working in the hospitality sector for over two decades and is a firm believer in the values of dedication and persistence. It is the biggest amusement park in Himachal Pradesh, and construction on it began in 2011. In a scant 16 months, it was finished, and on August 14, 2013, it opened its gates to the public for the first time."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: " It has over 20 activities, including slides and other entertainment attractions, to help you forget about your worries. Families and children of all ages may find their favorite foods at one of the many eateries located on the property. About 120 individuals make up our workforce, and everyone here is committed to doing a great job."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "d-flex",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                children: "25000+"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                            children: "Visit Per Month"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "mx-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                children: "150+"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                            children: "Awesome Team Members"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "".concat((About_module_default()).plan_sec, " row"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((About_module_default()).plan_sec_left, " col-md-4 common_title mobile_text_center"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-10",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                                ...settings,
                                className: "testi_slider",
                                children: testimonial.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/icons/quote.svg",
                                                width: 33,
                                                height: 33,
                                                alt: "Quote Icon"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: item.description
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: item.name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                children: item.title
                                            })
                                        ]
                                    }, index))
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((About_module_default()).plan_sec_right, " col-md-8"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/images/about-bottom-image.png",
                            layout: "fill",
                            objectFit: "cover",
                            alt: "About Image"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "".concat((About_module_default()).form_sec, " common_padding pb-0"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "common_title text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "Plan Your Adventure With Us"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form, {})
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 4199:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"top_banner":"Topbanner_top_banner__JLDvP","banner_text":"Topbanner_banner_text__znygP","banner_btn":"Topbanner_banner_btn___Zjwb","down":"Topbanner_down__3Pfwj","home_banner":"Topbanner_home_banner__p1RdH","banner_text_con":"Topbanner_banner_text_con__K9pZF","without_image_banner":"Topbanner_without_image_banner__U6U0K"};

/***/ }),

/***/ 240:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__C3as_","form_group":"Form_form_group__IR2Z3","form_control":"Form_form_control__8X8s8"};

/***/ }),

/***/ 9859:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"top_sec":"About_top_sec__aenlM","highlight_child":"About_highlight_child__5PxIS","about_main":"About_about_main__1DAUN","about_main_sec":"About_about_main_sec__suZG9","about_main_sec_right":"About_about_main_sec_right__940zy","left_child":"About_left_child__b0ZtZ","about_main_sec_left":"About_about_main_sec_left__JUErt","plan_sec":"About_plan_sec__RrIJf","plan_sec_left":"About_plan_sec_left__suQF_","plan_sec_right":"About_plan_sec_right__ekz25"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [458,594,791,774,888,179], function() { return __webpack_exec__(2879); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);